<section *ngIf="isVisible" class="favie__sidebar" [class.favie__sidebar--small]="!isExpand" [class.d__none]="isHide">
  <ng-template [ngIf]="logo">
    <div class="favie__sidebar__logo">
      <a [routerLink]="logo.routerLink">
        <img [class.d__none]="!isExpand" [src]="logo.src" />
        <img [class.d__none]="isExpand" [src]="logo.srcSmall" />
      </a>
    </div>
  </ng-template>

  <div class="favie__sidebar--inner-scroll">
    <ng-content select="[header]"></ng-content>

    <ul class="fav__sidebar-top-level-items">
      <div *ngFor="let item of items">
        <li class="favie__sidebar__item" *ngIf="!item.isHadSub" [class.active]="activeItem === item?.item"
          (click)="clickWithoutSubMenu()">
          <a [routerLink]="item.routerLink">
            <div class="favie__sidebar__item__highlight"></div>
            <mat-icon *ngIf="item?.matIcon">{{ item?.matIcon }}</mat-icon>
            <i *ngIf="item?.icon" class="icomoon" [class]="item?.icon"></i>
            <span class="label">{{ item.label }}</span>
          </a>
        </li>
        <div *ngIf="item.isHadSub" (mouseover)="onMouseHoverMenu(true,item)" (mouseleave)="onMouseHoverMenu(false,item)"
          (click)="item.isShowSub = true">
          <li class="favie__sidebar__item" [class.active]="!isExpand && activeItem === item?.item"
            (click)="clickWithoutSubMenu()">
            <a [routerLink]="item.routerLink" [queryParams]="item.routerParams">
              <div class="favie__sidebar__item__highlight"></div>
              <mat-icon *ngIf="item?.matIcon">{{ item?.matIcon }}</mat-icon>
              <i *ngIf="item?.icon" class="icomoon" [class]="item?.icon"></i>
              <span class="label">{{ item.label }}</span>
            </a>
          </li>
          <div *ngIf="isCurrentLink(item) || item.isShowSub || activeItem === item?.item">
            <li class="favie__sidebar__item" *ngFor="let sub of item.sub"
              [class.active]="isExpand && activeSubItem === sub?.item" [class.d__none]="!isExpand"
              (click)="clickWithoutSubMenu()">
              <a [routerLink]="sub.routerLink" [queryParams]="sub.routerParams">
                <div class="favie__sidebar__item__highlight"></div>
                <mat-icon *ngIf="sub?.matIcon">{{ sub?.matIcon }}</mat-icon>
                <i *ngIf="sub?.icon" class="icomoon" [class]="sub?.icon"></i>
                <div *ngIf="!sub?.matIcon && !sub?.icon" style="width: 20px;" class="sapce"></div>
                <span class="label">{{ sub.label }}</span>
              </a>
            </li>
          </div>

        </div>
      </div>

      <ng-content select="[content]"></ng-content>

      <li class="favie__sidebar__item collapse-item" [class.expanded]="isExpand">
        <a (click)="onToggleExpand()">
          <i class="icon-home"></i>
          <span [class.d__none]="!isExpand">Collapse sidebar</span>
        </a>
      </li>
    </ul>

    <ng-content select="[footer]"></ng-content>
  </div>
</section>